import Vue from 'vue'

const Events = {
  TEAM_CREATED: 'team:created',
  TEAM_UPDATED: 'team:updated',
  TEAM_DELETED: 'team:deleted',
  PLAYER_CREATED: 'player:created',
  PLAYER_UPDATED: 'player:updated',
  PLAYER_DELETED: 'player:deleted',
  COACH_CREATED: 'coach:created',
  COACH_UPDATED: 'coach:updated',
  COACH_DELETED: 'coach:deleted',
  LOCATION_CREATED: 'location:created',
  LOCATION_UPDATED: 'location:updated',
  LOCATION_DELETED: 'location:deleted',
  PERIOD_TAG_CREATED: 'period-tag:created',
  PERIOD_TAG_UPDATED: 'period-tag:updated',
  PERIOD_TAG_DELETED: 'period-tag:deleted',
  OPEN_DIALOG_PERIOD_TAG_FORM: 'open-dialog:period-tag-form',
  EDIT_PERIOD_TAG: 'edit:period-tag',
  MATCH_OPPONENT_CREATED: 'match-opponent:created',
  MATCH_OPPONENT_UPDATED: 'match-opponent:updated',
  MATCH_OPPONENT_DELETED: 'match-opponent:deleted',
  OPEN_DIALOG_MATCH_OPPONENT_FORM: 'open-dialog:match-opponent-form',
  EDIT_MATCH_OPPONENT: 'edit:match-opponent',
  PROTOCOL_CREATED: 'protocol:created',
  PROTOCOL_UPDATED: 'protocol:updated',
  PROTOCOL_DELETED: 'protocol:deleted',
  TRAINING_PROTOCOL_CREATED: 'training-protocol:created',
  TRAINING_PROTOCOL_UPDATED: 'training-protocol:updated',
  TRAINING_PROTOCOL_DELETED: 'training-protocol:deleted',
  TRAINING_EXERCISE_CREATED: 'training-exercise:created',
  TRAINING_EXERCISE_UPDATED: 'training-exercise:updated',
  TRAINING_EXERCISE_DELETED: 'training-exercise:deleted',
  TRAINING_PROGRAM_CREATED: 'training-program:created',
  TRAINING_PROGRAM_UPDATED: 'training-program:updated',
  TRAINING_PROGRAM_DELETED: 'training-program:deleted',
  TRAINING_PROGRAM_INSTANCE_CREATED: 'training-program-instance:created',
  TRAINING_PROGRAM_INSTANCE_UPDATED: 'training-program-instance:updated',
  TRAINING_PROGRAM_INSTANCE_DELETED: 'training-program-instance:deleted',
  TEST_SESSION_CREATED: 'test-session:created',
  TEST_SESSION_UPDATED: 'test-session:updated',
  TEST_SESSION_DELETED: 'test-session:deleted',
  EVENT_CREATED: 'event:created',
  EVENT_UPDATED: 'event:updated',
  EVENT_DELETED: 'event:deleted',
  EVENT_GROUP_CREATED: 'event-group:created',
  EVENT_GROUP_UPDATED: 'event-group:updated',
  EVENT_GROUP_DELETED: 'event-group:deleted',
  DIAGNOSTIC_RESULT_CREATED: 'diagnostic-result:created',
  DIAGNOSTIC_RESULT_UPDATED: 'diagnostic-result:updated',
  DIAGNOSTIC_RESULT_DELETED: 'diagnostic-result:deleted',
  DEVICE_CREATED: 'device:created',
  DEVICE_UPDATED: 'device:updated',
  DEVICE_DELETED: 'device:deleted',
  MEMBERSHIP_PLAN_CREATED: 'membership-plan:created',
  MEMBERSHIP_PLAN_UPDATED: 'membership-plan:updated',
  MEMBERSHIP_PLAN_DELETED: 'membership-plan:deleted',
  PARENT_CREATED: 'parent:created',
  PARENT_UPDATED: 'parent:updated',
  PARENT_DELETED: 'parent:deleted',
  INJURY_CREATED: 'injury:created',
  INJURY_UPDATED: 'injury:updated',
  INJURY_DELETED: 'injury:deleted',
  ILLNESS_CREATED: 'illness:created',
  ILLNESS_UPDATED: 'illness:updated',
  ILLNESS_DELETED: 'illness:deleted',
  DRILL_CREATED: 'drill:created',
  DRILL_UPDATED: 'drill:updated',
  DRILL_DELETED: 'drill:delete',
  LAYOUT_CREATED: 'layout:created',
  LAYOUT_UPDATED: 'layout:updated',
  LAYOUT_DELETED: 'layout:deleted',
  LAYOUTS_REORDER: 'layouts:reorder',
  ADD_LAYOUT: 'add:layout',
  EDIT_LAYOUT: 'edit:layout',
  OPEN_DIALOG_SELECT_FORM: 'open-dialog:select-form',
  OPEN_DIALOG_PLAYER_FORM: 'open-dialog:player-form',
  OPEN_DIALOG_TEAM_FORM: 'open-dialog:team-form',
  OPEN_DIALOG_COACH_FORM: 'open-dialog:coach-form',
  OPEN_DIALOG_EVENT_FORM: 'open-dialog:event-form',
  OPEN_DIALOG_INJURY_FORM: 'open-dialog:injury-form',
  OPEN_DIALOG_ILLNESS_FORM: 'open-dialog:illness-form',
  OPEN_DIALOG_LOCATION_FORM: 'open-dialog:location-form',
  OPEN_DIALOG_PROTOCOL_FORM: 'open-dialog:protocol-form',
  OPEN_DIALOG_TRAINING_PROTOCOL_FORM: 'open-dialog:training-protocol-form',
  OPEN_DIALOG_TRAINING_EXERCISE_FORM: 'open-dialog:training-exercise-form',
  OPEN_DIALOG_TRAINING_PROGRAM_FORM: 'open-dialog:training-program-form',
  OPEN_DIALOG_DIAGNOSTIC_RESULTS: 'open-dialog:diagnostic-results',
  OPEN_DIALOG_TEST_SESSION_FORM: 'open-dialog:test-session',
  OPEN_DIALOG_DEVICE: 'open-dialog:device',
  OPEN_DIALOG_MEMBERSHIP_PLAN_FORM: 'open-dialog:membership-plan-form',
  OPEN_DIALOG_TOURNAMENT_FORM: 'open-dialog:tournament-form',
  OPEN_DIALOG_QUESTIONNAIRE_INSTANCE_FORM: 'open-dialog:questionnaire-instance-form',
  OPEN_DIALOG_PARENT_FORM: 'open-dialog:parent',
  OPEN_DIALOG_CHANGE_LANGUAGE: 'open-dialog:language',
  OPEN_DIALOG_SUPPORT: 'open-dialog:support',
  EDIT_PLAYER: 'edit:player',
  EDIT_COACH: 'edit:coach',
  EDIT_PROFILE: 'edit:profile',
  EDIT_LOCATION: 'edit:location',
  EDIT_PROTOCOL: 'edit:protocol',
  EDIT_TRAINING_PROTOCOL: 'edit:training-protocol',
  EDIT_TRAINING_EXERCISE: 'edit:training-exercise',
  EDIT_TRAINING_PROGRAM: 'edit:training-program',
  LAUNCH_TRAINING_PROGRAM: 'launch:training-program',
  EDIT_TRAINING_PROGRAM_INSTANCE: 'edit:training-program-instance',
  EDIT_TEAM: 'edit:team',
  EDIT_DIAGNOSTIC_RESULT: 'edit:test-result',
  EDIT_DEVICE: 'edit:device',
  EDIT_EVENT: 'edit:event',
  EDIT_EVENT_GROUP: 'edit:event-group',
  EDIT_MEMBERSHIP_PLAN: 'edit:membership-plan',
  EDIT_PARENT: 'edit:parent',
  EDIT_INJURY: 'edit:injury',
  EDIT_ILLNESS: 'edit:illness',
  QUESTIONNAIRE_CREATED: 'questionnaire:created',
  QUESTIONNAIRE_UPDATED: 'questionnaire:updated',
  QUESTIONNAIRE_DELETED: 'questionnaire:deleted',
  EDIT_QUESTIONNAIRE: 'edit:questionnaire',
  QUESTIONNAIRE_INSTANCE_CREATED: 'questionnaire_instance:created',
  QUESTIONNAIRE_INSTANCE_UPDATED: 'questionnaire_instance:updated',
  QUESTIONNAIRE_INSTANCE_DELETED: 'questionnaire_instance:deleted',
  EDIT_QUESTIONNAIRE_INSTANCE: 'edit:questionnaire-instance'
}
Vue.prototype.$events = Events

declare module 'vue/types/vue' {
  interface Vue {
    $events: typeof Events;
  }
}

export const EventBus = new Vue()
